import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { createShippingCompany } from "../../../services/Admin/ShippingCompanyesApi";

const ShippingCompanyDialog = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState({ name: "", address: "", phone: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field) => (e) => setForm((p) => ({ ...p, [field]: e.target.value }));

  const handleSubmit = async () => {
    setError("");
    if (!form.name) {
      setError("الاسم مطلوب.");
      return;
    }
    setLoading(true);
    try {
      await createShippingCompany(form);
      setForm({ name: "", address: "", phone: "", email: "" });
      if (onSuccess) await onSuccess();
      if (onClose) onClose();
    } catch (err) {
      setError(err?.message || "فشل إنشاء شركة الشحن");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !loading && onClose && onClose()} fullWidth maxWidth="sm">
      <DialogTitle>إضافة شركة شحن</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="الاسم" value={form.name} onChange={handleChange("name")} fullWidth />
          <TextField label="العنوان" value={form.address} onChange={handleChange("address")} fullWidth />
          <TextField label="الهاتف" value={form.phone} onChange={handleChange("phone")} fullWidth />
          <TextField label="البريد الإلكتروني" value={form.email} onChange={handleChange("email")} fullWidth />
          {error ? <Typography color="error">{error}</Typography> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => !loading && onClose && onClose()}>إلغاء</Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained">
          {loading ? "جارٍ..." : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShippingCompanyDialog;
